import Navbar from "assets/Navbar";
import useDistrictData from "hook/useDistrictData";
import useFreeAmountDelivery from "hook/useFreeAmountDelivery";
import useUpazillaData from "hook/useUpzillaData";
import { useEffect, useRef, useState } from "react";
import {
  FaMinus,
  FaPlus,
  FaStore,
  FaTrash,
  FaTruck,
  FaTruckPickup,
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import RevealOnScroll from "components/RevealOnScroll";
import { getCartUpdatedEventName, setCheckoutSelectedItems } from "utils/cart";
import ShimmerOrderDetails from "components/shimmer/ShimmerOrderDetails";
import NoItem from "components/noItem";
import ScrollToTopButton from "components/ScrollToTopButton";
import CartTopSection from "components/cartComponents/cartTopSection";
const phoneRegex = /^01\d{9}$/;
const toCurrency = (amount) => `${amount.toLocaleString()} TK`;

const OrderDetails = () => {
  const { freeAmountDeliveryData } = useFreeAmountDelivery();
  const freeDeliveryAmount = freeAmountDeliveryData?.[0]?.amount || 0;

  const deliveryOptions = [
    { id: 1, label: "ঢাকার ভিতর", price: 70, icon: <FaTruck /> },
    { id: 2, label: "ঢাকার বাহিরে", price: 150, icon: <FaTruckPickup /> },
    { id: 3, label: "দোকান থেকে সংগ্রহ", price: 0, icon: <FaStore /> },
  ];
  const steps = [
    { id: 1, label: "Add Items", state: "done" },
    { id: 2, label: "Review Cart", state: "done" },
    { id: 3, label: "Order Now", state: "current" },
  ];

  const [form, setForm] = useState({
    name: "",
    phone: "",
    whatsappPhone: "",
    address: "",
    district: "",
    upazilla: "",
  });
  const orderPlacedRef = useRef(false);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [selectedOption, setSelectedOption] = useState(deliveryOptions[0]);
  const { district } = useDistrictData();
  const { upazilla } = useUpazillaData(form.district);
  const location = useLocation();
  const previousPathRef = useRef(location.pathname);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    setLoading(true);

    const storedItems = JSON.parse(localStorage.getItem("babyShop") || "[]");
    setProducts(storedItems);
    // Determine selectedIds
    const allKeys = storedItems.map((item) => String(item.item_id));
    const selectedIdsFromCart = location.state?.selectedIds || [];
    console.log(
      "ORDER DETAILS - location.state.selectedIds:",
      selectedIdsFromCart,
    );
    console.log("ORDER DETAILS - allKeys from localStorage:", allKeys);
    setSelectedIds(selectedIdsFromCart.length ? selectedIdsFromCart : allKeys);

    setLoading(false); // important!
  }, [location.state]);

  const hasVariantFreeDelivery = products
    .filter((item) => selectedIds.includes(String(item.item_id))) // 🔥 only selected
    .some((item) => Number(item?.selectedVariant?.freeVariantDelivery) === 1);

  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    localStorage.setItem("abandonedCheckoutForm", JSON.stringify(form));
  }, [form]);

  const updateLocalStorage = (items) => {
    localStorage.setItem("babyShop", JSON.stringify(items));
  };

  const removeItem = (index) => {
    const updated = [...products];
    updated.splice(index, 1);

    setProducts(updated);
    updateLocalStorage(updated);

    window.dispatchEvent(
      new CustomEvent(getCartUpdatedEventName(), {
        detail: {
          count: updated.reduce((sum, item) => sum + (item.quantity || 1), 0),
        },
      }),
    );

    if (updated.length === 0) {
      localStorage.removeItem("abandonedCheckoutForm");
    }
  };
  const getItemKey = (item) => String(item.item_id);
  const increaseQuantity = (index) => {
    const updated = [...products];
    updated[index].quantity = (updated[index].quantity || 1) + 1;
    setProducts(updated);
    updateLocalStorage(updated);
  };

  const decreaseQuantity = (index) => {
    const updated = [...products];
    if ((updated[index].quantity || 1) > 1) {
      updated[index].quantity -= 1;
      setProducts(updated);
      updateLocalStorage(updated);
    }
  };

  const handleToggleSelection = (id) => {
    const stringId = String(id);

    setSelectedIds((prev) =>
      prev.includes(stringId)
        ? prev.filter((v) => v !== stringId)
        : [...prev, stringId],
    );

    setErrors((prev) => ({ ...prev, selectedItems: "" }));
  };

  const validateField = (fieldName, value) => {
    const trimmed = String(value || "").trim();

    if (fieldName === "name") {
      if (!trimmed) return "আপনার নাম লিখুন";
      if (trimmed.length < 2) return "নাম কমপক্ষে ২ অক্ষরের হতে হবে";
      return "";
    }

    if (fieldName === "phone") {
      if (!trimmed) return "আপনার নাম্বার লিখুন";
      if (!phoneRegex.test(trimmed))
        return "নাম্বার ০১ দিয়ে শুরু হতে হবে এবং ১১ ডিজিটের হতে হবে";
      return "";
    }

    if (fieldName === "address") {
      if (!trimmed) return "সম্পূর্ন ঠিকানা লিখুন";
      return "";
    }

    if (fieldName === "district") {
      if (!trimmed) return "জেলা নির্বাচন করুন";
      return "";
    }

    if (fieldName === "whatsappPhone") {
      if (!trimmed) return "";
      if (!phoneRegex.test(trimmed))
        return "নাম্বার ০১ দিয়ে শুরু হতে হবে এবং ১১ ডিজিটের হতে হবে";
      return "";
    }

    return "";
  };

  const handleFieldChange = (fieldName, value) => {
    setForm((prev) => ({ ...prev, [fieldName]: value }));
    setErrors((prev) => ({
      ...prev,
      [fieldName]: validateField(fieldName, value),
      selectedItems: "",
    }));
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setCheckoutSelectedItems(selectedIds);
  }, [selectedIds]);

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  const validateForm = () => {
    const newErrors = {};

    newErrors.name = validateField("name", form.name);
    newErrors.phone = validateField("phone", form.phone);
    newErrors.address = validateField("address", form.address);
    newErrors.district = validateField("district", form.district);
    newErrors.whatsappPhone = validateField(
      "whatsappPhone",
      form.whatsappPhone,
    );

    // selected item validation
    if (selectedIds.length === 0) {
      newErrors.selectedItems = "কমপক্ষে একটি পণ্য নির্বাচন করুন";
    }

    // remove empty errors
    Object.keys(newErrors).forEach(
      (key) => !newErrors[key] && delete newErrors[key],
    );

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const sendAbandonedOrder = () => {
    if (orderPlacedRef.current) return;

    const savedForm = JSON.parse(
      localStorage.getItem("abandonedCheckoutForm") || "{}",
    );
    const savedProducts = JSON.parse(localStorage.getItem("babyShop") || "[]");

    if (!savedForm.name?.trim() || !savedForm.phone?.trim()) return;
    if (!savedProducts.length) return;

    const payload = {
      deliveryCharge: selectedOption.label,
      name: savedForm.name,
      phone: savedForm.phone,
      address: savedForm.address || "Not provided",
      district: savedForm.district || "Not provided",
      upazilla: savedForm.upazilla || "Not provided",
      items: savedProducts.map((p) => ({
        id: Number(p.item_id),
        variant_id: Number(p.selectedVariant?.variant_id),
        color: String(p.selectedColor),
        size: String(p.selectedSize),
        quantity: Number(p.quantity || 1),
        price: String(p.selectedPrice),
      })),
    };

    navigator.sendBeacon(
      "https://backend.nuhababy.com/storeUserCanceledOrder",
      new Blob([JSON.stringify(payload)], { type: "application/json" }),
    );
  };

  useEffect(() => {
    if (previousPathRef.current !== location.pathname) {
      sendAbandonedOrder();
    }

    previousPathRef.current = location.pathname;
  }, [location.pathname]);

  const handleSelectAll = () => {
    if (selectedIds.length === products.length) {
      // all selected → unselect all
      setSelectedIds([]);
    } else {
      // select all
      const allIds = products.map((item) => String(item.item_id));
      setSelectedIds(allIds);
    }
  };

  useEffect(() => {
    const handleLeavePage = () => {
      if (orderPlacedRef.current) return;

      const savedForm = JSON.parse(
        localStorage.getItem("abandonedCheckoutForm") || "{}",
      );
      const savedProducts = JSON.parse(
        localStorage.getItem("babyShop") || "[]",
      );

      if (!savedForm.name?.trim() || !savedForm.phone?.trim()) return;
      if (!savedProducts.length) return;

      const payload = {
        deliveryCharge: selectedOption.label,
        name: savedForm.name,
        phone: savedForm.phone,
        whatsappPhone: savedForm.whatsappPhone,
        address: savedForm.address || "Not provided",
        district: savedForm.district || "Not provided",
        upazilla: savedForm.upazilla || "Not provided",
        items: savedProducts.map((p) => ({
          id: Number(p.item_id),
          variant_id: Number(p.selectedVariant?.variant_id),
          color: String(p.selectedColor),
          size: String(p.selectedSize),
          quantity: Number(p.quantity || 1),
          price: String(p.selectedPrice),
        })),
      };

      navigator.sendBeacon(
        "https://backend.nuhababy.com/storeUserCanceledOrder",
        new Blob([JSON.stringify(payload)], { type: "application/json" }),
      );
    };

    window.addEventListener("beforeunload", handleLeavePage);

    return () => {
      handleLeavePage(); // route change
      window.removeEventListener("beforeunload", handleLeavePage);
    };
  }, []);

  const subtotal = products
    .filter((item) => selectedIds.includes(getItemKey(item)))
    .reduce(
      (total, item) =>
        total + (item.selectedVariant?.flashPrice || 0) * (item.quantity || 1),
      0,
    );

  const isFreeDelivery =
    hasVariantFreeDelivery ||
    (freeDeliveryAmount > 0 && subtotal >= freeDeliveryAmount);

  const finalDeliveryPrice = isFreeDelivery ? 0 : selectedOption.price;
  const finalDeliveryLabel = isFreeDelivery
    ? "Free Delivery"
    : selectedOption.label;

  const totalPrice = subtotal + finalDeliveryPrice;

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const selectedProducts = products.filter((p) =>
      selectedIds.includes(String(p.item_id)),
    );

    const selectedDistrict = district?.data?.find(
      (d) => String(d.id) === String(form.district),
    );

    const districtName = selectedDistrict ? selectedDistrict.bn_name : "";

    // Find the selected upazilla name from your upazilla list
    const selectedUpazilla = upazilla?.data?.find(
      (u) => u.bn_name === form.upazilla,
    );
    const upazillaName = selectedUpazilla ? selectedUpazilla.bn_name : "Test";
    const payload = {
      deliveryCharge: finalDeliveryLabel,
      deliveryAmount: finalDeliveryPrice,
      name: form.name,
      phone: form.phone,
      whatsappPhone: form.whatsappPhone,
      address: form.address,
      district: districtName,
      upazilla: upazillaName,
      items: selectedProducts.map((p) => ({
        id: Number(p.item_id),
        variant_id: Number(p.selectedVariant?.variant_id),
        color: String(p.selectedColor),
        size: String(p.selectedSize),
        quantity: Number(p.quantity || 1),
        price: String(p.selectedPrice),
      })),
    };

    try {
      const res = await fetch(`https://backend.nuhababy.com/order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.removeItem("abandonedCheckoutForm");
        localStorage.removeItem("babyShop");
        orderPlacedRef.current = true;

        setProducts([]);
        setForm({
          name: "",
          phone: "",
          whatsappPhone: "",
          address: "",
          district: "",
          upazilla: "",
        });
        // navigate(`/confirmOrder`);
      } else {
        toast.error("❌ অর্ডার ব্যর্থ হয়েছে।", {
          autoClose: 5000,
          closeOnClick: true,
        });
      }
    } catch (err) {
      toast.error("⚠️ নেটওয়ার্ক সমস্যার কারণে অর্ডার সম্পন্ন হয়নি।", {
        autoClose: 5000,
        closeOnClick: true,
      });
    }
  };

  return (
    <div className="bg-slate-50 min-h-screen ">
      <Navbar />
      {loading ? (
        <ShimmerOrderDetails />
      ) : products.length === 0 ? (
        <NoItem
          message="দুঃখিত! এই মুহূর্তে আপনার কার্টে কোনো পণ্য নেই। আপনি চাইলে নতুন পণ্য
        ব্রাউজ করতে পারেন।"
        />
      ) : (
        <>
          <main className="mx-auto w-full max-w-7xl mb-16">
            <RevealOnScroll>
              <CartTopSection
                steps={steps}
                subtitle="Step 3 of 3: Place your order."
              />
            </RevealOnScroll>
            <RevealOnScroll delayMs={70}>
              <div className="grid grid-cols-1 gap-5 xl:grid-cols-[1.1fr_1fr] px-4 sm:px-6">
                <section className="rounded-lg bg-white p-4 shadow-sm ring-1 ring-slate-100 sm:p-5">
                  <h1 className="text-lg font-bold text-slate-900 sm:text-2xl">
                    Customer Information
                  </h1>
                  <p className="mt-1 text-sm text-slate-600">
                    Fill the details to complete your order.
                  </p>
                  <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <div className="sm:col-span-2">
                      <label className="mb-1 block text-sm font-semibold text-slate-700">
                        নাম <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={form.name}
                        onChange={(event) =>
                          handleFieldChange("name", event.target.value)
                        }
                        className="w-full placeholder-gray-400 rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-blue-500"
                        placeholder="Enter your full name"
                      />
                      {errors.name ? (
                        <p className="mt-1 text-xs text-rose-600">
                          {errors.name}
                        </p>
                      ) : null}
                    </div>
                    <div>
                      <label className="mb-1 block text-sm font-semibold text-slate-700">
                        নাম্বার <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={form.phone}
                        onChange={(event) =>
                          handleFieldChange("phone", event.target.value)
                        }
                        className="w-full placeholder-gray-400 rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-blue-500"
                        placeholder="01XXXXXXXXX"
                      />
                      {errors.phone ? (
                        <p className="mt-1 text-xs text-rose-600">
                          {errors.phone}
                        </p>
                      ) : null}
                    </div>

                    <div>
                      <label className="mb-1 block text-sm font-semibold text-slate-700">
                        জেলা <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={form.district}
                        onChange={(event) =>
                          handleFieldChange("district", event.target.value)
                        }
                        className=" placeholder-gray-400 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-blue-500 "
                      >
                        <option value="">Select District</option>
                        {district?.data?.map((d) => (
                          <option key={d.id} value={d.id}>
                            {d.bn_name}
                          </option>
                        ))}
                      </select>
                      {errors.district ? (
                        <p className="mt-1 text-xs text-rose-600">
                          {errors.district}
                        </p>
                      ) : null}
                    </div>

                    <div className="sm:col-span-2">
                      <label className="mb-1 block text-sm font-semibold text-slate-700">
                        ঠিকানা <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        value={form.address}
                        onChange={(event) =>
                          handleFieldChange("address", event.target.value)
                        }
                        rows={3}
                        className="w-full placeholder-gray-400 rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-blue-500"
                        placeholder="House, road, area details"
                      />
                      {errors.address ? (
                        <p className="mt-1 text-xs text-rose-600">
                          {errors.address}
                        </p>
                      ) : null}
                    </div>

                    <div className="sm:col-span-2">
                      <label className="mb-1 block text-sm font-semibold text-slate-700">
                        Extra WhatsApp Number (Optional)
                      </label>
                      <input
                        type="text"
                        value={form.whatsappPhone}
                        onChange={(event) =>
                          handleFieldChange("whatsappPhone", event.target.value)
                        }
                        className="w-full placeholder-gray-400 rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-blue-500"
                        placeholder="01XXXXXXXXX"
                      />
                      {errors.whatsappPhone ? (
                        <p className="mt-1 text-xs text-rose-600">
                          {errors.whatsappPhone}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </section>
                <section className="rounded-lg bg-white p-4 sm:mb-5 mb-16 shadow-sm ring-1 ring-slate-100 sm:p-5">
                  <h1 className="text-lg font-bold text-slate-900 sm:text-2xl">
                    Order Details
                  </h1>
                  <p className="text-sm text-slate-600">
                    Select products and review charges before placing order.
                  </p>
                  <div className="mt-4 rounded-lg bg-slate-50 p-3 border">
                    <div className="mb-3 flex items-center justify-between">
                      <label className="inline-flex items-center gap-2 text-sm font-semibold">
                        <input
                          type="checkbox"
                          checked={
                            selectedIds.length === products.length &&
                            products.length > 0
                          }
                          style={{
                            appearance: "auto",
                            WebkitAppearance: "checkbox",
                            MozAppearance: "checkbox",
                          }}
                          onChange={handleSelectAll}
                          className="h-4 w-4"
                        />
                        Select All Items
                      </label>
                    </div>
                    <div className="max-h-80 space-y-2 overflow-y-auto pr-1">
                      {!products.length && (
                        <p className="rounded-md border border-slate-200 bg-slate-5 px-3 py-2 text-sm text-slate-200">
                          No items found in cart. Go back and add products
                          first.
                        </p>
                      )}
                      {products.map((item, index) => {
                        const key = getItemKey(item);
                        const checked = selectedIds.includes(key);
                        const qty = item.quantity || 1;
                        return (
                          <div
                            key={item.item_id}
                            onClick={() =>
                              handleToggleSelection(String(item.item_id))
                            }
                            className={`flex cursor-pointer items-center justify-between gap-2 rounded-md border px-3 py-2 text-sm ${
                              checked
                                ? "border-blue-300 bg-blue-50"
                                : "border-gray-200 bg-white hover:bg-gray-50"
                            }`}
                          >
                            <div className="flex min-w-0 flex-1 items-center gap-2">
                              <input
                                type="checkbox"
                                style={{
                                  appearance: "auto",
                                  WebkitAppearance: "checkbox",
                                  MozAppearance: "checkbox",
                                }}
                                checked={selectedIds.includes(
                                  String(item.item_id),
                                )}
                                onChange={(e) => {
                                  e.stopPropagation(); 
                                }}
                                className="h-4 w-4 "
                              />
                              <div className="h-14 w-14 flex-shrink-0 overflow-hidden rounded-md bg-gray-100">
                                <img
                                  src={`https://backend.nuhababy.com/${item.selectedVariant.images[0]}`}
                                  alt={item.selectedVariant?.title}
                                  className="h-full w-full object-cover"
                                />
                              </div>
                              <div className="min-w-0">
                                <p className="line-clamp-1 font-semibold">
                                  {item.mainTitle}
                                </p>
                                <p className="text-xs text-slate-600">
                                  {toCurrency(item.selectedVariant?.flashPrice)}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              <div className="inline-flex items-center rounded-md border border-slate-200 bg-slate-50">
                                <button
                                  type="button"
                                  disabled={qty === 1}
                                  onClick={(e) =>{ e.stopPropagation();  decreaseQuantity(index)}}
                                  className="inline-flex h-7 w-7 items-center justify-center disabled:cursor-not-allowed disabled:opacity-40"
                                >
                                  <FaMinus className="text-[10px]" />
                                </button>
                                <span className="inline-flex min-w-7 items-center justify-center text-xs font-bold">
                                  {qty}
                                </span>
                                <button
                                  type="button"
                                  onClick={(e) => { e.stopPropagation(); increaseQuantity(index)}}
                                  className="inline-flex h-7 w-7 items-center justify-center"
                                >
                                  <FaPlus className="text-[10px]" />
                                </button>
                              </div>
                              <button
                                type="button"
                                onClick={() => removeItem(index)}
                                className="inline-flex h-7 w-7 items-center justify-center rounded-md border border-rose-300 bg-rose-500 text-white hover:bg-rose-500"
                                aria-label={`Remove ${item.title}`}
                              >
                                <FaTrash className="text-[11px]" />
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {errors.selectedItems ? (
                      <p className="mt-2 text-xs text-rose-500">
                        {errors.selectedItems}
                      </p>
                    ) : null}
                  </div>

                  <div className="mt-4 rounded-lg bg-slate-50 border p-3">
                    <p className="mb-2 text-sm font-semibold">
                      Delivery Options
                    </p>
                    <div className="space-y-2">
                      {deliveryOptions.map((option) => (
                        <label
                          key={option.id}
                          className="flex cursor-pointer items-center justify-between rounded-md border border-slate-300 px-3 py-2 text-sm"
                        >
                          <span className="inline-flex items-center gap-2">
                            <input
                              type="radio"
                              name="delivery_option"
                              checked={selectedOption?.id === option.id}
                              onChange={() => handleChange(option)}
                              className="h-4 w-4"
                              style={{
                                appearance: "auto",
                                WebkitAppearance: "radio",
                                MozAppearance: "radio",
                              }}
                            />
                            {option.label}
                          </span>
                          <span className="font-semibold">
                            {toCurrency(option.price)}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="mt-4 rounded-lg bg-slate-100 p-3 text-sm">
                    <div className="flex items-center justify-between">
                      <span>Subtotal</span>
                      <span className="font-semibold">
                        {toCurrency(subtotal)}
                      </span>
                    </div>
                    <div className="mt-1 flex items-center justify-between">
                      <span>Delivery Charge</span>
                      <span className="font-semibold">
                        {toCurrency(finalDeliveryPrice)}
                      </span>
                    </div>
                    <div className="mt-2 border-t border-slate-200 pt-2 text-base font-bold">
                      <div className="flex items-center justify-between">
                        <span>Total</span>
                        <span>{toCurrency(totalPrice)}</span>
                      </div>
                    </div>
                  </div>
                  <div className="hidden sm:block">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      disabled={selectedIds.length === 0}
                      className="mt-4 w-full rounded-md bg-blue-600 px-4 py-2.5 text-sm font-bold text-white transition  disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      Order Now
                    </button>
                  </div>
                </section>
              </div>
            </RevealOnScroll>
          </main>
          <div className="fixed bottom-12 left-0 w-full z-50 bg-white border-t border-slate-200 p-3 sm:hidden">
            <button
              type="button"
              onClick={handleSubmit}
              disabled={selectedIds.length === 0}
              className=" w-full rounded-md bg-blue-600 px-4 py-2.5 text-sm font-bold text-white transition  disabled:cursor-not-allowed disabled:opacity-50"
            >
              Order Now
            </button>
          </div>
          <div className="container mx-auto px-4 sm:px-5 mt-5">
            <div className="flex flex-col lg:flex-row gap-3">
              {freeDeliveryAmount > 0 ? (
                <div className="mb-2">
                  <p className="flex items-center text-backgroundColor font-bold text-center">
                    🎁🎁 {freeDeliveryAmount} টাকার পণ্য কিনলেই পাচ্ছেন সারা
                    বাংলাদেশ ফ্রি ডেলিভারী অফার 🎁 🎁
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        </>
      )}

      {showScrollTop && <ScrollToTopButton />}

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default OrderDetails;
